$(document).ready(function() {
    // Add superscript to airflow label
    $('.sf-field-post-meta-airflow_mh_min h4').html('Airflow (m<sup>3</sup>/h) at 100Pa');
});